import { useEffect, useState } from "react";
import { withRouter, useHistory } from "react-router-dom";
import {
  getAllCustomersBySiteCode,
  getAllCustomersByCompanyCode,
  deleteCustomerByDocId,
} from "../../store/actions";
//redux
import { useSelector, useDispatch } from "react-redux";
import AddCustomer from "./add-customer";
import { useTranslation } from "react-i18next";
import AddCustomerBooking from "./add-customer-booking";
import TablePage, { makeColumns } from "src/components/Common/TablePage";



const Customers = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { customers, loading, success } = useSelector((state: any) => state.customer);
  const { currentUser } = useSelector((state: any) => state.login);
  const [showConfirmAlert, setShowConfirmAlert] = useState(false);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [customerList, setCustomerList] = useState<any>([]);
  const [currentCustomer, setCurrentCustomer] = useState<any>([]);
  const [drawer, setDrawer] = useState<Boolean>(false);
  const [drawerBooking, setDrawerBooking] = useState<Boolean>(false);
  const hasPermission = currentUser?.permissions?.customers;

  const defaultSorted: any = [
    {
      dataField: "siteCode", // if dataField is not match to any column you defined, it will be ignored.
      order: "desc", // desc or asc
    },
  ];

  useEffect(() => {
    if (currentUser?.LOGIN_METHOD === "COMPANY_LOGIN") {
      dispatch(getAllCustomersByCompanyCode(currentUser.code));
    }
    if (currentUser?.LOGIN_METHOD === "ADMIN_LOGIN") {
      dispatch(getAllCustomersBySiteCode(currentUser.siteCode));
    }
  }, [currentUser]);

  useEffect(() => {
    setCustomerList(customers);
  }, [customers]);

  const onEdit = (customer: any) => {
    history.push(`/customers/${customer.id}`);
  };

  const onDelete = (customer: any) => {
    setCurrentCustomer(customer);
    setShowConfirmAlert(true);
  };

  const confirmDelete = () => {
    setShowConfirmAlert(false);
    dispatch(deleteCustomerByDocId(currentCustomer.id));
    if (success) {
      setShowSuccessAlert(true)
    }
  };

  const onAdd = () => {
    setDrawer(true);
  };

  const onAddBooking = (customer: any) => {
    setDrawerBooking(true);
    setCurrentCustomer(customer);
  };

  const onDrawerClose = (value: Boolean) => {
    setDrawer(value);
  };

  const onDrawerBookingClose = (value: Boolean) => {
    setDrawerBooking(value);
  };

  return (
    <TablePage
      loading={loading}
      metaTitle={t("Customers")}
      data={customerList}
      onAdd={onAdd}
      hasPermission={hasPermission}
      title={t("customers.title")}
      description={`(${customers.length})`}
      columns={makeColumns(onDelete, onEdit, header, { icon: "book-open", onClick: onAddBooking })}
      pageSize={10}
      totalSize={customers.length}
      defaultSorted={defaultSorted}
      footer={
        <>
          <AddCustomer open={drawer} onDrawerClose={onDrawerClose} />
          <AddCustomerBooking open={drawerBooking} onDrawerBookingClose={onDrawerBookingClose} currentCustomer={currentCustomer} />
        </>
      }
      // Alerts
      confirmAlert={{
        visible: showConfirmAlert,
        onConfirm: confirmDelete,
        onCancel: () => setShowConfirmAlert(false)
      }}
      successAlert={{
        visible: showSuccessAlert,
        onConfirm: () => setShowSuccessAlert(false)
      }}
    />
  );
};

export default withRouter(Customers);

const header = [
  {
    dataField: "avatar",
    text: "Avatar",
    formatter: (_: any, customer: any) => (
      <img
        className="rounded-circle avatar-sm"
        src={customer?.avatar || "https://upload.wikimedia.org/wikipedia/commons/0/09/Man_Silhouette.png"}
        alt=""
      />
    ),
  },
  {
    dataField: "userName",
    text: "Username",
    sort: true,
  },
  {
    dataField: "siteCode",
    text: "Site Code",
    sort: true,
  },
  {
    dataField: "phone",
    text: "Phone",
    sort: true,
  },
  {
    dataField: "email",
    text: "Email",
    sort: true,
  },
  {
    dataField: "registered",
    text: "Registered",
    sort: true,
  },
  {
    dataField: "menu",
    editable: false,
    text: "Action"
  }
];
